import { render } from "./DropdownFilter.vue?vue&type=template&id=70fabff7&scoped=true"
import script from "./DropdownFilter.vue?vue&type=script&lang=js"
export * from "./DropdownFilter.vue?vue&type=script&lang=js"

import "./DropdownFilter.vue?vue&type=style&index=0&id=70fabff7&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-70fabff7"

export default script